import { render, staticRenderFns } from "./storage_inventory.vue?vue&type=template&id=3b95aa6e&scoped=true&"
import script from "./storage_inventory.vue?vue&type=script&lang=js&"
export * from "./storage_inventory.vue?vue&type=script&lang=js&"
import style0 from "./storage_inventory.vue?vue&type=style&index=0&id=3b95aa6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95aa6e",
  null
  
)

export default component.exports